import { render, staticRenderFns } from "./ValueTags.vue?vue&type=template&id=4376bcb9&"
import script from "./ValueTags.vue?vue&type=script&lang=js&"
export * from "./ValueTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports